  $(document).ready(function(){    
$('.slick-carousel ').slick({
    infinite: false,
     arrows: true,
    speed: 600,
     dots:false,
    slidesToShow: 1,
    slidesToScroll: 1,
    navigation: true
});
  });


$(document).ready(function(){
 $('.radio').click(function(){
           if($(this).is(":checked")) {
             $(this).parent().parent().find('.radio').removeClass('active');
         $(this).addClass('active'); 
     }  
    
    });
});
